export const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: [0.25, 0.1, 0.25, 1], // Faster, standard easing
        }
    }
};

export const staggerContainer = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            staggerChildren: 0.1,
            delayChildren: 0.02
        }
    }
};

export const slideInFromLeft = {
    hidden: { x: -30, opacity: 0 },
    visible: {
        x: 0,
        opacity: 1,
        transition: {
            duration: 0.5,
            ease: [0.25, 0.1, 0.25, 1],
        }
    }
};

export const reveal = {
    hidden: { opacity: 0, scale: 0.98, y: 10 },
    visible: {
        opacity: 1,
        scale: 1,
        y: 0,
        transition: {
            duration: 0.5,
            ease: [0.25, 0.1, 0.25, 1],
        }
    }
};

export const premiumSpring = {
    type: "spring",
    stiffness: 120,
    damping: 20,
    mass: 1
};

export const hoverScale = {
    scale: 1.02,
    transition: {
        duration: 0.2,
        ease: "easeOut"
    }
};

// Simplified glow for performance
export const backgroundGlow = {
    animate: {
        opacity: [0.1, 0.15, 0.1],
        transition: {
            duration: 10,
            repeat: Infinity,
            ease: "linear"
        }
    }
};
